export const spamManagementCopy = {
  title: '',
  description: '',
  optionSpam: '',
  optionInbox: '',
  optionTagSpam: '',
  optionTrash: '',
};
